import { Feature } from '@tencent/workbench';
import { AngleFrom, DragAngleCircleType } from '@tencent/wb-ext-form';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { AngleOptions } from '@framework/workbench/drawer/common/config';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';

@Feature()
export class RotateFeature extends BaseDrawerFeature {
    public get rotate(): number {
        const rotate = (this.getSelectModel() as IMultiplyModel | IElementBaseModel)?.getFrame?.()
            ?.getRotate(true);
        return isNaN(rotate) ? NaN : rotate;
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.ROTATE)
    public handleRotateChange(value: number, from?: AngleFrom, dragState?: DragAngleCircleType): void {
        if (this.isInputOnlyChangeUI()) return;
        const model = this.getSelectModel();
        value = this.fixMultiModelValue(value, from) % 360;
        if (typeof dragState === 'undefined') {
            (this.getSelectModel() as IMultiplyModel).getFrame?.()
                ?.updateRotate(value, true);
        } else {
            const scale = this.getAppService().viewableServiceLayer.editAreaCanvasSizeManager.getCanvasScale();
            const dragMap = {
                [DragAngleCircleType.START]: () => this.rotateHandler?.handleRotateStart(
                    model as IElementBaseModel,
                    scale,
                ),
                [DragAngleCircleType.DRAGGING]: () => this.rotateHandler?.updateRotateWhileRotating(value),
                [DragAngleCircleType.STOP]: () => {
                    this.rotateHandler?.updateRotateWhileRotating(value);
                    this.rotateHandler?.handleRotateStop();
                },
            };
            dragMap[dragState]?.();
        }
        this.tdwDrawerReportAngle(
            FormItemName.LAYOUT_ROTATE, from, value
            , dragState && dragState !== DragAngleCircleType.STOP,
        );
    }

    private fixMultiModelValue = (value: number | string, from?: AngleFrom): number => {
        if (this.isMultiModel() && isNaN(this.rotate)) {
            const { rotate } = this.getMultiModelRotateInfo();
            // 当多选角度不同时，-按钮时传入的value为0，+按钮时value为step
            if (from === AngleFrom.ADD_BTN) {
                value = rotate + AngleOptions.step;
            }
            if (from === AngleFrom.REDUCE_BTN) {
                value = rotate - AngleOptions.step;
            }
        }
        return value as number;
    };

    private getMultiModelRotateInfo = () => {
        let rotate = 0;
        const rotateList: any[] = [];
        const { selectedModels } = (this.getSelectModel() as IMultiplyModel);
        selectedModels.forEach((model) => {
            if (model.type !== UIModelType.TABLE) {
                const { rotate } = model.props.style;
                if (rotateList.indexOf(rotate) === -1) {
                    rotateList.push(rotate);
                }
            }
        });
        rotate = rotateList[0];
        return { rotate };
    };

    private get rotateHandler() {
        return (this.getAppService() as any as IMobileEditorAppServices).editableServiceLayer?.rotateElementHandler;
    }
}
